/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  Component,
  JSXElement,
  createSignal,
  createEffect,
  onMount,
  onCleanup,
  For,
  Show,
} from 'solid-js';

const HiddenStyle = { display: 'none', pointerEvents: 'none' } as const;

interface IWidth {
  width?: string;
  [key: string]: string | undefined;
}

export interface TabsProps {
  selected?: number;
  selectedTab?: string;
  allowClose?: boolean;
  className?: string;
  tabSelectorClass?: string;
  tabDragBarClass?: string;
  tabButtonClass?: string;
  tabContentClass?: string;
  onSelectedChanged?(index: number, key?: string): void;
  onHandleTouchEvents?(resizing: boolean): void;
  movedX?: number;
  finishedMoving?: number;
  minWidth?: number;
  onTabsRendered?(ids: string[]): void;
  content?: JSXElement; // Use content prop instead of children
  // Callback props for event handling
  onTabSelected?(index: number, key?: string): void;
}

const Tabs: Component<TabsProps> = (props): JSXElement => {
  let toolbarContainer: HTMLDivElement | undefined;

  const [width, setWidth] = createSignal<IWidth>({});
  const [resizing, setResizing] = createSignal(false);

  // Helper function to get children as array
  const getChildrenArray = () => {
    if (!props.content) return [];

    // Handle both single element and array of elements
    if (Array.isArray(props.content)) {
      return props.content;
    }
    return [props.content];
  };

  const classNames = (
    ...classes: (string | Record<string, boolean> | undefined)[]
  ): string => {
    return classes
      .filter(Boolean)
      .map((cls) => {
        if (typeof cls === 'string') return cls;
        if (typeof cls === 'object') {
          return Object.entries(cls)
            .filter(([, value]) => value)
            .map(([key]) => key)
            .join(' ');
        }
        return '';
      })
      .join(' ')
      .trim();
  };

  const htmlToString = (htmlText: string): string => {
    if (!htmlText) return '';
    const div = document.createElement('div');
    div.innerHTML = htmlText;
    return div.textContent ?? div.innerText ?? '';
  };

  const slideOnScroll = (e: WheelEvent) => {
    (e.currentTarget as HTMLDivElement).scrollBy({
      top: e.deltaX + e.deltaY,
    });

    if (!e.defaultPrevented) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const onDown = (event: MouseEvent | TouchEvent) => {
    event.preventDefault();
    triggerResizing(true);
  };

  const stopResizing = () => {
    triggerResizing(false);
  };

  const resize = (x: number) => {
    if (props.minWidth && x < props.minWidth) {
      return;
    }

    const newWidth = x + 0.12 + 'rem';
    setWidth({ width: newWidth });
  };

  const triggerResizing = (isResizing: boolean) => {
    if (resizing() !== isResizing) {
      if (props.onHandleTouchEvents) {
        props.onHandleTouchEvents(isResizing);
      }
      setResizing(isResizing);
    }
  };

  const handleClick = (index: number, event: MouseEvent, tab: any) => {
    event.preventDefault();

    // Call callback if provided
    if (props.onTabSelected) {
      props.onTabSelected(index, tab);
    }

    //@outdated Legacy callback support
    if (props.onSelectedChanged) {
      if (
        (props.selected === index || props.selectedTab === tab) &&
        props.allowClose
      ) {
        props.onSelectedChanged(-1, undefined);
      } else if (props.selected !== index) {
        props.onSelectedChanged(index, tab);
      }
    }
  };

  const renderIcon = (icon: string) => {
    let className = '';
    if (icon.startsWith('trimble-icon')) {
      className = classNames('trimble-icon', icon);
    } else if (icon.startsWith('tc-icon')) {
      className = classNames('trimble-icon', 'icon-font', icon);
    } else {
      className = classNames('icon-font', icon);
    }

    return (
      <span class={className}>
        <span class="path1" />
        <span class="path2" />
        <span class="path3" />
        <span class="path4" />
      </span>
    );
  };

  // Handle movedX and finishedMoving props changes
  createEffect(() => {
    if (resizing()) {
      if (props.movedX !== undefined) {
        resize(props.movedX);
      } else if (props.finishedMoving !== undefined) {
        stopResizing();
      }
    }
  });

  // Handle onTabsRendered callback
  createEffect(() => {
    if (props.onTabsRendered) {
      const children = getChildrenArray();
      const renderedTabKeys = children.reduce<string[]>((prev, curr: any) => {
        if (curr?.key) {
          prev.push(curr.key);
        }
        return prev;
      }, []);

      if (renderedTabKeys.length > 0) {
        props.onTabsRendered(renderedTabKeys);
      }
    }
  });

  onMount(() => {
    if (toolbarContainer) {
      toolbarContainer.addEventListener('wheel', slideOnScroll, {
        passive: false,
      });
    }
  });

  onCleanup(() => {
    if (toolbarContainer) {
      toolbarContainer.removeEventListener('wheel', slideOnScroll, {
        passive: false,
      } as unknown as EventListenerOptions);
    }
  });

  const getSelectedChild = () => {
    const children = getChildrenArray();
    const selection =
      (props.selected !== undefined && props.selected > -1) ||
      props.selectedTab;

    for (let index = 0; index < children.length; index++) {
      const child = children[index] as any;
      if (child && child.props) {
        if (typeof selection === 'string') {
          if (child.key === selection) {
            return child;
          }
        } else if (typeof selection === 'number' && selection === index) {
          return child;
        }
      }
    }
    return null;
  };

  const hasChildSelected = () => {
    const children = getChildrenArray();
    return children.some(
      (child: any) => child && child.props && child.props.selected
    );
  };

  return (
    <div
      class={classNames(
        props.className || 'trimble-workspace-tabs no-menu-toolbar',
        {
          selected:
            !!getSelectedChild() &&
            ((props.selected !== undefined && props.selected > -1) ||
              !!props.selectedTab),
        }
      )}
      style={getSelectedChild() ? width() : {}}
    >
      <div
        class={classNames(props.tabSelectorClass || 'trimble-tabs-selector', {
          selected: !!getSelectedChild() || hasChildSelected(),
        })}
      >
        <div class="tabs-full-height">
          <div ref={toolbarContainer} class="tabs-full-height">
            <For each={getChildrenArray()}>
              {(child: any, index) => {
                const isSelected = () =>
                  index() === props.selected ||
                  child.key === props.selectedTab ||
                  child.props.selected;
                const dataTip = () => htmlToString(child.props.iconDataTip);

                return (
                  <Show when={child && child.props}>
                    <button
                      class={classNames(
                        props.tabButtonClass || 'trimble-tabs-selector-button',
                        { selected: isSelected() },
                        child.props.className
                      )}
                      title={dataTip() ? '' : child.props.iconTitle}
                      data-tip={dataTip()}
                      onClick={(e: MouseEvent) => {
                        handleClick(index(), e, child.props.key);
                      }}
                      disabled={
                        typeof child.props.disabled === 'boolean' &&
                        child.props.disabled
                      }
                      data-cy={child.key + '-tab-button'}
                    >
                      <Show when={child.props.iconUrl}>
                        <img src={child.props.iconUrl} />
                      </Show>
                      <Show when={!child.props.iconUrl && child.props.icon}>
                        {/* eslint-disable-next-line custom/no-direct-solid-component-invocation -- Tracked by https://jira.trimble.tools/browse/TWENG-38 */}
                        {renderIcon(child.props.icon)}
                      </Show>
                      <Show when={child.props.label}>
                        <span class="trimble-tabs-selector-button-label">
                          {child.props.label}
                        </span>
                      </Show>
                      <Show when={child.props.badge}>
                        <span class="trimble-tabs-selector-button-badge">
                          {child.props.badge}
                        </span>
                      </Show>
                    </button>
                  </Show>
                );
              }}
            </For>
          </div>
        </div>
      </div>
      <For each={getChildrenArray()}>
        {(child: any, index) => {
          const isSelected = () =>
            index() === props.selected || child.key === props.selectedTab;
          return (
            <Show when={child}>
              <div
                class={classNames(
                  props.tabContentClass || 'trimble-tabs-content',
                  { selected: isSelected() }
                )}
                style={isSelected() ? {} : HiddenStyle}
              >
                {child}
              </div>
            </Show>
          );
        }}
      </For>
      <div
        class={props.tabDragBarClass}
        onMouseDown={onDown}
        onTouchStart={onDown as any}
        style={
          getSelectedChild()
            ? resizing()
              ? { ...{}, 'padding-left': '100%' }
              : {}
            : HiddenStyle
        }
      />
    </div>
  );
};

export default Tabs;
